// ## Data
export const sessions = [
  {
    id: 1,
    title: 'Portaging for Posers',
    speaker: 'Trey Smith',
    blurb: 'How to look like you know how to carry a canoe, without actually carrying a canoe.',
    location: '9 Parakeet Pond',
    day: 'Thursday',
    time: '9:00 AM',
    duration: '30 Minutes',
    workshop: false
  },
  {
    id: 2,
    title: 'Is this edible?',
    speaker: 'Will Smith',
    blurb: 'Berries and mushrooms and herbs, oh my! Learn how to spot the difference between nature’s candy and nature’s poison.',
    location: '2 Wallaby Way',
    day: 'Thursday',
    time: '9:00 AM',
    duration: '45 Minutes',
    workshop: true
  },
  {
    id: 3,
    title: 'Litter-ature',
    speaker: 'Jada Smith',
    blurb: 'In this paws-on session, we’ll create effective and engaging signage to discourage visitors from littering.',
    location: '7 Salamander Street',
    day: 'Thursday',
    time: '9:00 AM',
    duration: '45 Minutes',
    workshop: true
  },
  {
    id: 4,
    title: 'S’mores Sesh',
    speaker: 'Jaden Smith',
    blurb: 'The best session of them all, S’mores Sesh is basically a chance to sit around and eat s’mores.',
    location: '4 Lagoon Lane',
    day: 'Thursday',
    time: '9:00 AM',
    duration: '30 Minutes',
    workshop: false
  },
  {
    id: 4,
    title: 'Basket Weaving 102',
    speaker: 'Willow Smith',
    blurb: 'Hot on the trail of Basket Weaving 101, we’ll explore how to make even bigger baskets!',
    location: '6 Meerkat Mall',
    day: 'Thursday',
    time: '9:00 AM',
    duration: '60 Minutes',
    workshop: false
  },
];

const DAY = 'Wednesday';
const TIME = '10:00 AM - 11:00 AM';

export const keynotes = [
  {
    id: 1,
    title: 'Choosing Your Path',
    blurb: 'Listen as Jamie discusses choosing your own path.',
    date: DAY,
    time: TIME,
    location: '7 Garden Grove',
    videoSrc: 'assets/videos/blueShirt.mov',
    captionSrc: 'assets/videos/captionManager.vtt',
    transcript: 'I think Choosing Your Path will really appeal to anyone looking to make the transition from "doer" to "manager." We\'ll have a diverse panel of speakers who\'ve been there, done that, and have insight into the challenges of becoming a manager for the first time.'
  },
  {
    id: 2,
    title: 'Forging Your Trail',
    blurb: 'Listen as Morgan shares more about forging your trail!',
    date: DAY,
    time: TIME,
    location: '4 Lagoon Lane',
    videoSrc: 'assets/videos/yellowShirt.mov',
    captionSrc: 'assets/videos/captionDeveloper.vtt',
    transcript: 'Look, as a developer, I love staying up-to-date with the latest trends in technology. But it can be really hard, you know, with how much is changing. Forging a Trail will give you a broad overview of the trends shaping the developer\'s world, and a high-level look at what tools and frameworks you should be aware of.'
  },
];

export const lunchTimes = ['11:00', '11:30', '12:00', '12:30'];

export const mealOptions = [
  'Salad (Vegan)',
  'Salad (Veggie)',
  'Sandwich (Chicken)',
  'Sandwich (Chicken, Gluten-Free)',
  'Sandwich (Veggie)',
  'Sandwich (Veggie, Gluten-Free)'
].map((value, i) => {return {id: i, label: value}});

export const drinkOptions = [
  'Apple Juice',
  'Lemonade',
  'Iced Tea',
  'Cola',
  'Diet Cola'
].map((value, i) => {return {id: i, label: value}});

export const dessertOptions = [
  'Nothing for me, thanks!',
  'Brownie',
  'Cupcake (Chocolate)',
  'Cupcake (Red Velvet)',
  'Cupcake (Vanilla)',
  'Cookie (Chocolate Chip)',
  'Cookie (Oatmeal Raisin)',
  'Cookie (Peanut Butter)',
  'Watermelon'
].map((value, i) => {return {id: i, label: value}});



// WEBPACK FOOTER //
// ./src/data.js